/**
 * The page origin, drawn in canvas space: the fixed point the sketch's
 * absolute coordinates (and the agent's projection) are measured from, with
 * little axes showing x running east and y running north.
 */
const SIZE = 64;
const C = SIZE / 2;
const R = 5;
const AXIS = 22;

export function OriginMarker() {
  const stroke = "var(--tl-color-text-3)";
  return (
    <div
      style={{
        position: "absolute",
        left: -C,
        top: -C,
        width: SIZE,
        height: SIZE,
        pointerEvents: "none",
      }}
    >
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
        <circle
          cx={C}
          cy={C}
          r={R}
          fill="none"
          stroke={stroke}
          strokeWidth={1.25}
        />
        {/* x east */}
        <line
          x1={C + R}
          y1={C}
          x2={C + AXIS}
          y2={C}
          stroke={stroke}
          strokeWidth={1}
        />
        <path d={`M ${C + AXIS} ${C} l -4 -2.5 v 5 z`} fill={stroke} />
        <text
          x={C + AXIS + 3}
          y={C}
          dominantBaseline="central"
          fontSize={9}
          fontFamily="var(--tl-font-draw)"
          fill={stroke}
        >
          x
        </text>
        {/* y north */}
        <line
          x1={C}
          y1={C - R}
          x2={C}
          y2={C - AXIS}
          stroke={stroke}
          strokeWidth={1}
        />
        <path d={`M ${C} ${C - AXIS} l -2.5 4 h 5 z`} fill={stroke} />
        <text
          x={C}
          y={C - AXIS - 6}
          textAnchor="middle"
          fontSize={9}
          fontFamily="var(--tl-font-draw)"
          fill={stroke}
        >
          y
        </text>
      </svg>
    </div>
  );
}
